"use strict";
var Observable_1 = require('../../Observable');
var publishBehavior_1 = require('../../operator/publishBehavior');
Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
//# sourceMappingURL=publishBehavior.js.map


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/~/rxjs/add/operator/publishBehavior.js
// module id = ../../../../rxjs/add/operator/publishBehavior.js
// module chunks = 5